var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-perf-overlay"},[_c('fps',{attrs:{"current-fps":_vm.currentFps}}),_c('memory',{attrs:{"statistics":_vm.memoryUsage}}),_c('components',{attrs:{"component-count":_vm.componentCount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }